/**
 * assets/collection-section.js
 * Gedrag van sections/collection.liquid
 *
 * Geknipt uit het {% javascript %}-blok van die section op 16-08-2026, 1:1.
 * Shopify plakte die blokken tot één compiled_assets/scripts.js dat op elke
 * pagina laadde, ook waar de section niet voorkwam. Nu laadt alleen deze
 * section zijn eigen gedrag. Zie ARCHITECTURE.md sectie 11.
 */

/*
 * Eenmalige uitvoering. Shopify voegde alle {% javascript %}-blokken samen tot
 * één bestand dat precies één keer draaide, ongeacht hoe vaak de section op de
 * pagina stond. Deze guard houdt dat gedrag exact gelijk nu elke section zijn
 * eigen script-tag rendert.
 */
(function () {
  'use strict';
  if (window.__vc_collectionSection) return;
  window.__vc_collectionSection = true;

  const section = document.getElementById('collection-section');
    if (!section) return;

    // Debounce helper for price inputs
    let priceDebounceTimer = null;
    function debouncedApplyFilters(source, delay = 800) {
      clearTimeout(priceDebounceTimer);
      priceDebounceTimer = setTimeout(() => applyFilters(source), delay);
    }

    // Desktop filters, instant filtering on change
    section.querySelectorAll('[data-filter-input]').forEach(input => {
      if (input.type === 'number') {
        input.addEventListener('input', () => debouncedApplyFilters('desktop'));
      } else {
        input.addEventListener('change', () => applyFilters('desktop'));
      }
    });

    // Mobile filter dialog
    const filterToggle = section.querySelector('[data-filter-toggle]');
    const filterDialog = document.getElementById('filter-dialog');
    if (filterToggle && filterDialog) {
      filterToggle.addEventListener('click', () => filterDialog.showModal());
      filterDialog.addEventListener('click', (e) => { if (e.target === filterDialog) filterDialog.close(); });
      filterDialog.querySelectorAll('[data-filter-input-mobile]').forEach(input => {
        input.addEventListener('change', () => applyFilters('mobile'));
      });
    }

    // Sort select
    const sortSelect = section.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => applyFilters('desktop'));
    }

    // === AJAX Load More ===
    bindLoadMore();

    function bindLoadMore() {
      const btn = section.querySelector('[data-load-more]');
      if (!btn) return;

      btn.addEventListener('click', async () => {
        const nextUrl = btn.dataset.nextUrl;
        if (!nextUrl) return;

        const textEl = btn.querySelector('[data-load-more-text]');
        const spinner = btn.querySelector('[data-load-more-spinner]');
        const icon = btn.querySelector('[data-load-more-icon]');
        const originalText = textEl.textContent;
        textEl.textContent = 'Laden…';
        if (spinner) spinner.classList.remove('hidden');
        if (icon) icon.classList.add('hidden');
        btn.disabled = true;
        btn.classList.add('opacity-60');

        try {
          const separator = nextUrl.includes('?') ? '&' : '?';
          const res = await fetch(`${nextUrl}${separator}sections=collection`);
          const json = await res.json();
          const html = json['collection'];

          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const newGrid = tmp.querySelector('[data-product-grid-inner]');
          const newPagination = tmp.querySelector('[data-pagination-wrapper]');

          if (newGrid) {
            const currentGrid = section.querySelector('[data-product-grid-inner]');
            const fragment = document.createDocumentFragment();
            Array.from(newGrid.children).forEach(child => {
              child.style.opacity = '0';
              child.style.translate = '0 16px';
              fragment.appendChild(child);
            });
            currentGrid.appendChild(fragment);

            requestAnimationFrame(() => {
              currentGrid.querySelectorAll('[style*="opacity: 0"]').forEach((card, i) => {
                setTimeout(() => {
                  card.style.transition = 'opacity 0.4s ease, translate 0.4s ease';
                  card.style.opacity = '1';
                  card.style.translate = '0';
                }, i * 50);
              });
            });
          }

          const currentPagination = section.querySelector('[data-pagination-wrapper]');
          if (newPagination && currentPagination) {
            currentPagination.replaceWith(newPagination);
            bindLoadMore();
          } else if (currentPagination && !newPagination) {
            currentPagination.innerHTML = `
              <div class="flex items-center gap-2 text-sm text-aqua-donker font-semibold">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                Alle producten geladen
              </div>
            `;
          }

          window.history.replaceState({}, '', nextUrl);
        } catch(err) {
          console.error('Load more error:', err);
          window.location.href = nextUrl;
        }
      });
    }

    // === Filter Logic ===
    async function applyFilters(source) {
      const form = source === 'mobile'
        ? document.querySelector('[data-filter-form-mobile]')
        : section.querySelector('[data-filter-form]');

      const url = new URL(window.location.href);
      const params = new URLSearchParams();

      const currentSort = section.querySelector('[data-sort-select]');
      if (currentSort && currentSort.value) params.set('sort_by', currentSort.value);

      if (form) {
        form.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
          params.append(cb.name, cb.value);
        });
        form.querySelectorAll('input[type="number"], input[data-price-input]').forEach(input => {
          if (input.value) params.set(input.name, String(input.value).trim().replace(/\s/g, '').replace(',', '.'));
        });
      }

      const newUrl = `${url.pathname}?${params.toString()}`;

      const grid = section.querySelector('[data-products-grid]');
      grid.style.opacity = '0.4';
      grid.style.transition = 'opacity 0.2s';

      try {
        const res = await fetch(`${newUrl}&sections=collection`);
        const json = await res.json();
        const html = json['collection'];

        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newSection = tmp.querySelector('#collection-section');

        if (newSection) {
          section.innerHTML = newSection.innerHTML;
          window.history.pushState({}, '', newUrl);
          bindFilterEvents();
          bindLoadMore();
        }
      } catch(err) {
        window.location.href = newUrl;
      }
    }

    function bindFilterEvents() {
      section.querySelectorAll('[data-filter-input]').forEach(input => {
        if (input.type === 'number') {
          input.addEventListener('input', () => debouncedApplyFilters('desktop'));
        } else {
          input.addEventListener('change', () => applyFilters('desktop'));
        }
      });
      const newSort = section.querySelector('[data-sort-select]');
      if (newSort) newSort.addEventListener('change', () => applyFilters('desktop'));
      const newToggle = section.querySelector('[data-filter-toggle]');
      if (newToggle && filterDialog) newToggle.addEventListener('click', () => filterDialog.showModal());
    
      bindFilterSearch();
    }

    // Shopify availability means sellable, including CONTINUE backorders.
    // Product-card labels communicate physical stock and supplier lead time.

    // Run on initial load
  
    bindFilterSearch();

    // === Filter Search (inline search within large filter groups) ===
    function bindFilterSearch() {
      section.querySelectorAll('[data-filter-search]').forEach(input => {
        const groupKey = input.dataset.filterSearch;
        const list = section.querySelector(`[data-filter-list="${groupKey}"]`);
        if (!list) return;

        input.addEventListener('input', () => {
          const query = input.value.toLowerCase().trim();
          list.querySelectorAll('[data-filter-value]').forEach(label => {
            const text = label.dataset.filterValue;
            label.style.display = (!query || text.includes(query)) ? '' : 'none';
          });
        });
      });
    }

    window.addEventListener('popstate', () => window.location.reload());
})();
